import { BasicProps } from "@components/ComponentsInterface";
import { Permission, PermissionCategory } from "@store/generalTypes";
import { PermissionDetail } from "./permissionDetail";

export const PermissionList = ({ permissions }: PermissionListProps): JSX.Element => {
    return (
        <div className="has-background-success-light py-4 px-6">
            <h1 className="has-text-ldark-gray is-6 pb-4">PERMISSION DETAILS</h1>
            <PermissionDetail
                title="Administrative"
                permissions={permissions.filter((x) => x.category === PermissionCategory.administrative)}
            />
            <PermissionDetail
                title="Assessment-based"
                permissions={permissions.filter((x) => x.category === PermissionCategory.assessmentBased)}
            />
            <PermissionDetail
                title="Results-based"
                permissions={permissions.filter((x) => x.category === PermissionCategory.resultBased)}
            />
        </div>
    );
};

interface PermissionListProps extends BasicProps {
    permissions: Permission[];
}
